
























import { defineComponent, PropType } from '@vue/composition-api'
import {
  mdiInformationOutline,
} from '@mdi/js'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'

export default defineComponent({
  name: 'AggregationTableTitle',
  props: {
    aggregation: {
      type: Object as PropType<AggregationResultAttributes>,
      required: true,
    },
  },
  setup() {
    return {
      icons: {
        mdiInformationOutline,
      },
    }
  },
})
